export default __webpack_public_path__ + "static/media/arrow-left-green-2.0d518dc6.svg";